module.exports = __webpack_public_path__ + "img/2h.9fbaa9db.png";